import classNames from 'classnames';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { CardItem } from './cardItem';
import { useStyles } from './useStyles';

export const CardCollection = ({
  title, textColor, bgColor, items
}) => {
  const classes = useStyles();

  const totalItems = items.length;
  const cardItems = items.map(({
    // eslint-disable-next-line no-shadow
    text, textColor, bgColor
  }, index) => {
    const isLastItem = totalItems - 1 === index;

    return (
      <CardItem
        // eslint-disable-next-line react/no-array-index-key
        key={text + index}
        text={text}
        textColor={textColor}
        bgColor={bgColor}
        className={!isLastItem && classes.itemGap}
      />
    );
  });

  return (
    <Grid container spacing={2} className={classes.itemGap}>
      <Grid item xs={7}>
        {cardItems}
      </Grid>
      <Grid item xs={5}>
        <CardItem
          text={title}
          align="center"
          textColor={textColor}
          bgColor={bgColor}
          isCollectionTitle
          className={classNames(classes.collectionBox)}
        />
      </Grid>
    </Grid>
  );
};

CardCollection.propTypes = {
  title: PropTypes.string,
  textColor: PropTypes.oneOf(['focus00', 'focus90']),
  bgColor: PropTypes.string,
  items:    PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    textColor: PropTypes.oneOf(['focus00', 'focus90']),
    bgColor: PropTypes.string
  }))
};

CardCollection.defaultProps = {
  title: 'Collection',
  textColor: 'focus00',
  bgColor: '#000000',
  items: []
};
